import { useEffect, useState } from 'react';

import { DonutChart } from 'src/lib';
import { BalanceSummaryView } from 'src/models';
import { Color } from 'src/styles';

interface BalanceSummaryChartProps {
  summary: Omit<BalanceSummaryView, 'cashBalance'>;
}

const colorMapping: Record<string, string> = {
  accountValue: Color.Brand7,
  cashAvailable: Color.Green7,
  pendingTransfersTotal: Color.Orange7,
  tradedPositionsTotal: Color.Brand7,
  nonTradedPositionsTotal: Color.Brand9,
  workingOrdersTotal: Color.Red9,
  pendingOfferOrdersTotal: Color.Red7,
};

export const BalanceSummaryChart = ({ summary }: BalanceSummaryChartProps) => {
  const [totalValues, setTotalValues] = useState<number[]>([]);
  const [colors, setColors] = useState<string[]>([]);

  const isLoading =
    summary.accountValue.isLoading ||
    summary.cashAvailable.isLoading ||
    summary.tradedPositionsTotal.isLoading ||
    summary.nonTradedPositionsTotal.isLoading ||
    summary.pendingOfferOrdersTotal.isLoading;

  const hasError =
    summary.accountValue.hasError ||
    summary.cashAvailable.hasError ||
    summary.tradedPositionsTotal.hasError ||
    summary.nonTradedPositionsTotal.hasError ||
    summary.pendingOfferOrdersTotal.hasError;

  const error =
    summary.accountValue.error ||
    summary.cashAvailable.error ||
    summary.tradedPositionsTotal.error ||
    summary.nonTradedPositionsTotal.error ||
    summary.pendingOfferOrdersTotal.error;

  useEffect(() => {
    const totalValues: number[] = [];
    const colors: string[] = [];

    if (summary.cashAvailable.value > 0) {
      totalValues.push(summary.cashAvailable.value);
      colors.push(colorMapping['cashAvailable']);
    }

    totalValues.push(summary.tradedPositionsTotal.value);
    colors.push(colorMapping['tradedPositionsTotal']);
    totalValues.push(summary.nonTradedPositionsTotal.value);
    colors.push(colorMapping['nonTradedPositionsTotal']);
    totalValues.push(summary.workingOrdersTotal.value);
    colors.push(colorMapping['workingOrdersTotal']);
    totalValues.push(summary.pendingOfferOrdersTotal.value);
    colors.push(colorMapping['pendingOfferOrdersTotal']);

    setTotalValues(totalValues);
    setColors(colors);
  }, [summary]);

  return (
    <DonutChart
      data={totalValues}
      colors={colors}
      total={summary.accountValue.value}
      isLoading={isLoading}
      hasError={hasError}
      error={error}
    />
  );
};
